import { Box, styled } from '@mui/material';

import { Colors } from 'Themes/colors';

export const Divider = styled(Box)`
  align-self: stretch;
  width: 2px;
  background: ${Colors.lineGrey};
  margin: 0;
  flex: 0 1 1px;
`;
